import React, { useEffect, useState } from 'react'
import styles from '../styles/Reviews.module.scss'
import { BUSINESS_QUERY } from '../apollo/query/business'
import { useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import Helmet from 'react-helmet'
import MoodStep from '../components/MoodStep'
import { ThankYouHappyStep } from '../components/ThankYouHappyStep'
import { InTouchShortlyStep } from '../components/InTouchShortlyStep'
import { ThankYouUnHappyStep } from '../components/ThankYouUnHappyStep'
import { NotContactMeOrMaybeLatterStep } from '../components/NotContactMeOrMaybeLatterStep'
import { NotContactMeOrMaybeLatterHappy } from '../components/NotContactMeOrMaybeLatterHappy'
import { AdBlock } from '../components/AdBlock'
import { Footer } from '../components/Footer'

export type Step = 'mood' | 'in-touch-shortly' | 'google-review' | 'thank-you-happy' | 'thank-you-unhappy' | 'not-contact-me' | 'not-contact-me-unhappy'

type LoyaltyProgramSetting = {
  id: number
  loyaltyProgramName: string
  defaultPointCount: number
}

type BusinessFeatures = {
  instantReviews: boolean
  instantReviewRating: boolean
  instantReviewComment: boolean
  instantReviewImageUpload: boolean
  instantReviewName: boolean
  instantReviewsAdBlock: boolean
}

export type InstantReviewSocialMedia = {
  id: number
  iconUrl?: string
  name?: string
  url?: string
  position?: number
}

export type Business = {
  id: number
  name?: string
  slug?: string
  useContactMeFormInstantReviews?: boolean
  instantReviewFeedbackImgUrl: string
  businessFeatures: BusinessFeatures
  loyaltyProgramSetting: LoyaltyProgramSetting
  instantReviewSocialMedia: [InstantReviewSocialMedia]
}

type FormValues = {
  review: string
  firstName: string
  phone: string
}

function ReviewFormPage () {
  // @ts-ignore
  const { id } = useParams()
  const [step, setStep] = useState<Step>('mood')
  const [reviewId, setReviewId] = useState<number>()
  const [mood, setMood] = useState<number>()
  const [formValues, setFormValues] = useState<FormValues>({
    review: '',
    firstName: '',
    phone: '',
  })

  const { loading, data } = useQuery(
    BUSINESS_QUERY,
    {
      fetchPolicy: 'network-only',
      variables: { slug: id },
    },
  )

  const business = data?.businessBySlug
  const businessFeatures = business?.businessFeatures

  useEffect(() => {
    const bubbleContainer = document.getElementsByClassName('wwvw-bubble-container')
    while (bubbleContainer?.length > 0) {
      bubbleContainer?.[0]?.parentNode?.removeChild(bubbleContainer[0])
    }
  }, [])

  if ((!business?.businessFeatures?.instantReviews || !business?.id) && !loading) {
    return null
  }

  const onUpdateFormValues = (name: string, value: string) => {
    setFormValues({
      ...formValues,
      [name]: value
    })
  }

  const stepIsMood = step === 'mood'
  const showAdBlock = businessFeatures?.instantReviewsAdBlock && step === 'thank-you-happy'

  return (
    <>
      <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-203638305-1" />
        <script src="/scripts.js" />
      </Helmet>
        <main>
          <section className={styles.container}>
            <div className={styles.nav}>
              {loading ? 'Loading...' : business?.name}
            </div>

            {
              stepIsMood && <MoodStep
                setReviewId={setReviewId}
                setStep={setStep}
                business={business}
                onUpdateFormValues={onUpdateFormValues}
                setMood={setMood}
              />
            }

            {
              step === 'thank-you-happy' && (
                <ThankYouHappyStep
                  setStep={setStep}
                  business={business}
                  review={formValues.review}
                  reviewId={reviewId}
                />
              )
            }

            {
              (business?.useContactMeFormInstantReviews && step === 'thank-you-unhappy') && (
                <ThankYouUnHappyStep
                  setStep={setStep}
                  reviewId={reviewId}
                  onUpdateFormValues={onUpdateFormValues}
                  firstName={formValues.firstName}
                />
              )
            }

            {
              step === 'in-touch-shortly' && <InTouchShortlyStep
                firstName={formValues.firstName}
                phone={formValues.phone}
              />
            }

            {
              step === 'not-contact-me' && <NotContactMeOrMaybeLatterHappy mood={mood} />
            }
            {
              step === 'not-contact-me-unhappy' && <NotContactMeOrMaybeLatterStep />
            }

            {
              showAdBlock && <AdBlock stepIsMood={stepIsMood} />
            }

            {
              !showAdBlock && <Footer stepIsMood={stepIsMood} />
            }
          </section>
        </main>
    </>
  )
}

export default ReviewFormPage
